/**
 * Checks if an array is empty
 * 
 * @param {*} value 
 * @returns {Boolean}
 */
const isEmptyArray = (value) => Array.isArray(value)
    ? (value.length === 0)
    : false

/**
 * Checks if an object is empty
 * 
 * @param {*} value 
 * @returns {Boolean}
 */
const isEmptyObject = (value) => (value instanceof Object && value?.constructor === Object)
    ? (Object.keys(value).length === 0)
    : false

/**
 * Rule to check if the field contains a value
 */
export default {
    name     : 'required',
    validate : (value) => value !== ''
        && value !== undefined
        && value !== null
        && !isEmptyArray(value)
        && !isEmptyObject(value),
    message: field => `The field ${field} is required`
}